import img_download from "assets/img/download.svg";
import img_loading from "assets/img/loading.svg";

import { MenuItemButton } from "components/menu/MenuItemButton";
import { useConstructAndDownloadNotificationDocument } from "hooks/useConstructAndDownloadNotificationDocument";

export const MenuItemButtonConstructAndDownloadNotificationDocument = ({
  applicationId,
}) => {
  const { isPending, download } = useConstructAndDownloadNotificationDocument();
  return (
    <MenuItemButton
      onClick={() => download(applicationId)}
      disabled={isPending}
      title={isPending ? "Загрузка..." : "Cкачать документ-уведомление"}
      iconSrc={isPending ? img_loading : img_download}
    />
  );
};
